import { Label } from '@fluentui/react-components';
import { useMsal } from '@azure/msal-react';
import { createFileRoute, Outlet, redirect, useChildMatches } from '@tanstack/react-router';
import { useEffect, useRef, useState } from 'react';
import MailFolderTree from '../../components/MailFolderTree/MailFolderTree';
import '../../styles/PermissionManager.css';

export const Route = createFileRoute('/_auth/folder')({
  beforeLoad: async (beforeLoadContextOptions) => {
    if (beforeLoadContextOptions.context.licenseChecker.getHasUserValidLicense()) {
      return;
    }

    throw redirect({
      to: '/LicenseIssue',
    });
  },
  component: RouteComponent,
});

const DEFAULT_LEFT_WIDTH = 280;
const MIN_LEFT_WIDTH = 180;
const MAX_LEFT_WIDTH = 600;

function RouteComponent() {
  const childMatches = useChildMatches();
  const selectedFolderId = childMatches.map((m) => (m.params as { folderId?: string }).folderId).find(Boolean);

  const [leftWidth, setLeftWidth] = useState<number>(DEFAULT_LEFT_WIDTH);
  const { instance } = useMsal();

  const isDragging = useRef(false);
  const dragStartX = useRef(0);
  const dragStartWidth = useRef(0);

  const handleDividerMouseDown = (e: React.MouseEvent) => {
    isDragging.current = true;
    dragStartX.current = e.clientX;
    dragStartWidth.current = leftWidth;
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  };

  useEffect(() => {
    const onMouseMove = (e: MouseEvent) => {
      if (!isDragging.current) return;
      const delta = e.clientX - dragStartX.current;
      const newWidth = Math.min(MAX_LEFT_WIDTH, Math.max(MIN_LEFT_WIDTH, dragStartWidth.current + delta));
      setLeftWidth(newWidth);
    };

    const onMouseUp = () => {
      if (!isDragging.current) return;
      isDragging.current = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
  }, []);

  return (
    <div className="container">
      <div className="container-grid">
        <div className="left" style={{ width: leftWidth }}>
          <Label size="large" className="left-header">
            {instance.getActiveAccount()?.username}
          </Label>
          <MailFolderTree onSelectedFolder={() => {}} selectedFolderId={selectedFolderId} />
        </div>
        <div className="divider" onMouseDown={handleDividerMouseDown} />
        <div className="right">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
